// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__Ga-De","MainSlider":"Home_MainSlider__KjydX","Popup":"Home_Popup__1N0OR","HeaderContainer":"Home_HeaderContainer__3eqVU"};